import { createSvgComponent } from "../../icon/createSvgComponent";
import WelloPoint from "@core/icon/assets/wello-point.svg";
export default createSvgComponent(WelloPoint);